import { locale } from '@local/config';
import es from './es.json';
import en from './en.json';
import vi from './vi.json';

export const getI18n = lang => ({ es, en, vi })[lang || locale()] ?? en;
